import React from 'react';
import { TString } from '../../Response/Utils';
import { getImg } from '../../../../Utils/getImg';
interface Props {
  isBotDeployed: 'true' | 'false' | undefined;
  encryptedBotId: string;
  redirectToExternalBot: Function;
  isBotPublic: true | false | undefined;
  isInsideCampaign: boolean;
}

export default function SharePane(props: Props) {
  const [link, setLink] = React.useState('');
  const [isLinkCopied, setIsLinkCopied] = React.useState(false);

  React.useEffect(() => {
    let timer;
    if (isLinkCopied) {
      timer = setTimeout(setIsLinkCopied, 1000, false);
    }
    return () => clearTimeout(timer);
  }, [isLinkCopied]);

  React.useEffect(() => {
    setLink(
      `${window.origin}/chatsdk.html?botID=${encodeURIComponent(
        props.encryptedBotId
      )}`
    );
  }, [props.encryptedBotId, props.isBotDeployed]);

  const setShareWidth = () => {
    try {
      document.getElementById('sharePaneW').style.width =
        (window.innerWidth < 800 && window.innerWidth > 550) ||
        (window.screen.width < 800 && window.screen.width > 550) ||
        (props.isInsideCampaign &&
          window.innerWidth > 550 &&
          window.screen.width > 550)
          ? `${window.innerWidth - 40}px`
          : !props.isInsideCampaign &&
            window.innerWidth > 800 &&
            window.screen.width > 800
          ? '20vw'
          : '80vw';
    } catch (e) {
      console.log(e);
    }
  };

  setShareWidth();
  window.addEventListener('resize', setShareWidth, false);

  function handleCopy() {
    if (navigator && navigator.clipboard) {
      navigator.clipboard
        .writeText(link)
        .then(
          () => setIsLinkCopied(true),
          err => console.info(err)
        )
        .catch(err => console.error(err));
    }
  }
  return (
    <div
      id="sharePaneW"
      className="share-pane-w"
      onClick={e => e.stopPropagation()}
    >
      {props.isBotPublic === false ? (
        <div className="share-pane-info">
          <img
            src={getImg('icons/lock.svg')}
            alt={TString({ labelName: 'privateBotLabel' })}
            title={TString({ labelName: 'privateBotLabel' })}
          />
          <div>
            This bot is private. Please make it public from bot configurations
            to enable the shareable testing link.
          </div>
        </div>
      ) : (
        <>
          <div>Share the bot for testing</div>
          <div>
            Share this link with test users to collect and analyse their
            responses and feedback
          </div>
          <div>
            <input
              value={link}
              onChange={e => e.preventDefault()}
              className="sf-link-preview"
            />
            <button className="share-pane-button" onClick={handleCopy}>
              <img
                src={getImg('icons/copy.svg')}
                alt={TString({ labelName: 'copyIconLabel' })}
                className="clickable"
                title={TString({ labelName: 'copyIconLabel' })}
              />
            </button>
            <button
              className="share-pane-button"
              onClick={() => props.redirectToExternalBot()}
            >
              <img
                src={getImg('icons/expand.svg')}
                alt={TString({ labelName: 'expandIconLabel' })}
                className="clickable"
                title={TString({ labelName: 'expandIconLabel' })}
              />
            </button>
            {isLinkCopied ? (
              <div className="sf-link-copied" aria-live="polite">
                Link Copied
              </div>
            ) : null}
          </div>
          {props.isBotDeployed === 'true' ? null : (
            <div>
              <img
                src={getImg('icons/warning-red.svg')}
                alt={TString({ labelName: 'redWarningIconLabel' })}
              />
              <div>
                The bot in testing link will not respond until you deploy a
                version of the bot.
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
